var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-07ecb08c-2174-41b8-a715-c2d875f19b5b",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-b10a4873-8b11-44b1-948b-cda22e6e6917 {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-b10a4873-8b11-44b1-948b-cda22e6e6917",
    d: "M18.95,23h-9.19c-.41,0-.75-.34-.75-.75s.34-.75.75-.75h9.19c.41,0,.75.34.75.75s-.34.75-.75.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-b10a4873-8b11-44b1-948b-cda22e6e6917",
    d: "M13.29,20.32c-.5,0-.94-.11-1.22-.38-.91-.91.02-3.63.53-4.14l6.24-6.24c.35-.35.81-.54,1.31-.54h0c.5,0,.96.19,1.31.54l.99.99c.35.35.54.81.54,1.31,0,.5-.19.96-.54,1.31l-6.24,6.24c-.35.35-1.79.92-2.93.92ZM20.16,11.07l-6.14,6.14c-.07.13-.21.64-.29,1.07.44-.08.97-.24,1.15-.35l6.06-6.07-.78-.78Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/Create.ef934174bb665d440f70aec5a5d2c1bb.svg";
export { ForwardRef as ReactComponent };